import SALARYBYENGLISHLEVEL from 'data/mantechcar25/salary-by-english-level.json';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import {
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const SalaryByEnglishLevel: React.FC = () => {
  const { t } = useI18n('developer-career-report-2025');
  const { locale } = useRouter();

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={400} width="99%" minWidth={500}>
          <LineChart
            width={500}
            height={300}
            data={SALARYBYENGLISHLEVEL}
            margin={{
              top: 45,
              right: 35,
              left: 20,
              bottom: 0
            }}
          >
            <XAxis
              dataKey={(data) => data.years[locale || 'en']}
              tickLine={false}
              axisLine={true}
              tickMargin={5}
            />
            <YAxis
              type="number"
              tickLine={false}
              axisLine={true}
              tickMargin={10}
              tickFormatter={(tick: number) => {
                return `€${(Math.sign(tick) * (Math.abs(tick) / 1000)).toFixed(
                  0
                )}K`;
              }}
            />
            <Tooltip
              cursor={{ fill: '#d9ceff' }}
              labelStyle={{
                fontWeight: 'bold',
                textTransform: 'uppercase',
                borderBottom: '1px solid #837e93',
                marginBottom: '8px',
                fontSize: '12px'
              }}
              separator=": "
              formatter={(value: number) => `€${value.toLocaleString(locale)}`}
              wrapperClassName="tooltip-x"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ top: 0 }}
            />
            <Line
              strokeWidth={4}
              dot={{ stroke: '#A29EAE', strokeWidth: 1, r: 4 }}
              type="monotone"
              dataKey="basic"
              stroke="#1B9D76"
              name={t('mantechcar25.benefits.english.basic')}
            />
            <Line
              strokeWidth={4}
              dot={{ stroke: '#A29EAE', strokeWidth: 1, r: 4 }}
              type="monotone"
              dataKey="intermediate"
              stroke="#D95F02"
              name={t('mantechcar25.benefits.english.intermediate')}
            />
            <Line
              strokeWidth={4}
              dot={{ stroke: '#A29EAE', strokeWidth: 1, r: 4 }}
              type="monotone"
              dataKey="fluent"
              stroke="#746FB3"
              name={t('mantechcar25.benefits.english.fluent')}
            />
            <Line
              strokeWidth={4}
              dot={{ stroke: '#A29EAE', strokeWidth: 1, r: 4 }}
              type="monotone"
              dataKey="native"
              stroke="#E7278A"
              name={t('mantechcar25.benefits.english.native')}
            />
          </LineChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default SalaryByEnglishLevel;
